export const TOAST_AUTO_CLOSE_MS = 3000;

/** The face crop of `public/mascot.png`: 62 KB instead of 1.8 MB for a 44px disc. */
export const TOAST_MASCOT_SRC = "/assets/images/mascot-head.webp";

export const TOAST_MASCOT_SIZE = 44;

/** At most this many on screen; the rest wait their turn instead of walling off the page. */
export const TOAST_LIMIT = 3;

export const TOAST_TITLE_KEYS = {
  success: "toast.title.success",
  error: "toast.title.error",
  warning: "toast.title.warning",
  info: "toast.title.info",
} as const;
